import { Page } from "@/models/page-models/Page";

export const GoodsEditorView: Page = {
  "path": "goodsEditor/:goodId",
  "name": "Goods Editor",
  "props": {
    "data": {
      "title": "Goods Editor",
      "printable": "FALSE",
      "url": "goodsEditor/:goodId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "label": "RM Identity"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.good.type",
                  "label": "RM Type",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "copyRMFamilyData"
                    }
                  ],
                  "disabled": "TRUE",
                  "items": "fetchedData.rmIdentity.data.0.data",
                  "itemText": "name",
                  "itemValue": "name",
                  "validationKey": "type"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.good.family",
                  "label": "RM Family",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "copyRMCategoryData"
                    }
                  ],
                  "disabled": "TRUE",
                  "showIf": "{{fetchedData.selectedRMFamily}}",
                  "items": "fetchedData.selectedRMFamily",
                  "itemText": "name",
                  "itemValue": "name",
                  "validationKey": "family"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.good.category",
                  "label": "RM Category",
                  "disabled": "TRUE",
                  "showIf": "{{fetchedData.selectedRMCategory}}",
                  "items": "fetchedData.selectedRMCategory",
                  "itemText": "name",
                  "itemValue": "name",
                  "validationKey": "category"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "label",
                  "label": "RM General Specs"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.good.mainSpecification",
                  "label": "Main Specification",
                  "disabled": "TRUE"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedSupplierId",
                  "label": "Supplier",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "name": "copySupplierData"
                    }
                  ],
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "getAgentData"
                    }
                  ],
                  "disabled": "TRUE",
                  "items": "fetchedData.supplierList.data",
                  "itemText": "name",
                  "itemValue": "_id"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedAgent",
                  "label": "Agent",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "name": "copyAgentData"
                    }
                  ],
                  "disabled": "TRUE",
                  "items": "fetchedData.agentData.data",
                  "itemText": "name",
                  "itemValue": "_id"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.good.rmAlias.0",
                  "label": "RM Alias",
                  "disabled": "TRUE",
                  "items": "fetchedData.rmAliases.data",
                  "itemText": "alias",
                  "itemValue": "_id"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.good.thickness",
                  "label": "Thickness",
                  "unit": "micron",
                  "disabled": "TRUE",
                  "validationKey": "thickness"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.good.densityUnit",
                  "label": "Type of Density",
                  "disabled": "TRUE",
                  "items": "[{\"text\":\"Volumetric Density\",\"value\":\"KG/m3\"},{\"text\":\"Surface Density\",\"value\":\"GSM\"}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "formData.good.density",
                  "label": "Density",
                  "unit": "{{formData.good.densityUnit}}",
                  "disabled": "TRUE",
                  "validationKey": "density"
                },
                {
                  "type": "input",
                  "variable": "formData.good.color",
                  "label": "Color",
                  "disabled": "TRUE"
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Dimensions(in mm)"
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.good.dimensions.length",
                  "label": "Length",
                  "unit": "mm",
                  "disabled": "TRUE",
                  "validationKey": "dimensions.length"
                },
                {
                  "type": "input",
                  "variable": "formData.good.dimensions.width",
                  "label": "Width",
                  "unit": "mm",
                  "disabled": "TRUE",
                  "validationKey": "dimensions.width"
                },
                {
                  "type": "input",
                  "variable": "formData.dimensions.height",
                  "label": "Height",
                  "unit": "mm",
                  "disabled": "TRUE",
                  "validationKey": "dimensions.height"
                }
              ]
            },
            {
              "name": "8",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.good.supGrade",
                  "label": "Sup Grade",
                  "disabled": "TRUE",
                  "featureFlag": "451-hide-sup-grade"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.good.rawMaterialUnit",
                  "label": "Unit",
                  "disabled": "TRUE",
                  "items": "[\"KG\",\"SQM\",\"PCs\",\"LM\"]",
                  "dropdownType": "static",
                  "validationKey": "rawMaterialUnit"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.good.form",
                  "label": "Form Of Good",
                  "disabled": "TRUE",
                  "items": "[\"roll\",\"sheet\"]",
                  "dropdownType": "static"
                }
              ]
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.good.unitWeight",
                  "label": "Unit Weight",
                  "unit": "KG",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "formData.good.perKgRatio.plA.value",
                  "label": "Pieces Per KG",
                  "unit": "Pcs",
                  "disabled": "TRUE"
                }
              ]
            },
            {
              "name": "10",
              "pageItems": [
                {
                  "type": "label",
                  "label": "PSL Only",
                  "showIf": "fn(LOGICAL,'{{formData.good.family}}',===,'PSL')"
                }
              ]
            },
            {
              "name": "11",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.good.psl.facestockType",
                  "label": "PSL Facestock Material Type",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "formData.good.psl.linerType",
                  "label": "PSL Liner Material Type",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "formData.good.psl.adhesiveType",
                  "label": "PSL Adhesive Material Type",
                  "disabled": "TRUE"
                }
              ],
              "showIf": "fn(LOGICAL,'{{formData.good.family}}',===,'PSL')"
            },
            {
              "name": "12",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.good.psl.facestockGsm",
                  "label": "PSL Facestock GSM",
                  "unit": "GSM",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "formData.good.psl.facestockCaliper",
                  "label": "PSL Facestock Caliper",
                  "unit": "micron",
                  "disabled": "TRUE"
                }
              ],
              "showIf": "fn(LOGICAL,'{{formData.good.family}}',===,'PSL')"
            },
            {
              "name": "13",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.good.psl.linerGsm",
                  "label": "PSL Liner GSM",
                  "unit": "GSM",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "formData.good.psl.linerCaliper",
                  "label": "PSL Liner Caliper",
                  "unit": "micron",
                  "disabled": "TRUE"
                }
              ],
              "showIf": "fn(LOGICAL,'{{formData.good.family}}',===,'PSL')"
            },
            {
              "name": "14",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.good.notes",
                  "label": "Notes",
                  "disabled": "TRUE"
                }
              ]
            },
            {
              "name": "15",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Quantity",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,goodsLocationsOverview,{{formData.good.location}})"
                },
                {
                  "type": "label",
                  "variable": "formData.good.packingMode",
                  "label": "Packing",
                  "showIf": "fn(LENGTH,{{formData.good.packingMode}})",
                  "labelType": "formula",
                  "formula": "fn(CONCAT,{{formData.good.packingMode.0.quantity}} , {{formData.good.packingMode.0.unit1}}, / ,{{formData.good.packingMode.0.unit2}},\n,fn(CONDITIONAL,fn(LOGICAL,fn(LENGTH,{{formData.good.packingMode}}),>,1),fn(CONCAT,{{formData.good.packingMode.1.quantity}} , {{formData.good.packingMode.1.unit1}} ,/ ,{{formData.good.packingMode.1.unit2}}),))"
                }
              ]
            },
            {
              "name": "16",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Save",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "saveGood"
                    }
                  ],
                  "disabled": "TRUE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getRmIdentityData"
      },
      {
        "executionOrder": 1,
        "name": "getUnitsForDropdown"
      },
      {
        "executionOrder": 2,
        "name": "loadSelectedGood"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllSuppliers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/suppliers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierList"
        },
        "name": "getAllSuppliers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Commercial | Purchaser))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMySuppliers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/suppliers/my",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierList"
        },
        "name": "getMySuppliers",
        "executeIf": "fn(MATCH_ROLE,Commercial | Purchaser)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllRmAliases",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/rm-alias/get",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.rmAliases"
        },
        "name": "getAllRmAliases"
      }
    ],
    "functions": [
      {
        "name": "loadSelectedGood",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/goods/detail?id={{__params.goodId}}",
        "arg2Key": "storeInVar",
        "arg2Value": "formData",
        "arg3Key": "sourceTransformationFn",
        "arg3Value": "transformGoodsData",
        "arg4Key": "fnsAfterSubmit",
        "arg4Value": "[{\"name\":\"copySupplierId\",\"executionOrder\":1},{\"name\":\"copyAgentId\",\"executionOrder\":2}]"
      },
      {
        "name": "transformGoodsData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "good": "__selectedObject.data.0"
        }
      },
      {
        "name": "copySupplierId",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "formData.good.supplier._id",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedSupplierId"
      },
      {
        "name": "copyAgentId",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "formData.good.agent._id",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedAgent"
      },
      {
        "name": "getRmIdentityData",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/staticdata?type=rm-identity",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.rmIdentity"
      },
      {
        "name": "getUnitsForDropdown",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/staticdata?type=unit_v2",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.units"
      },
      {
        "name": "copyRMFamilyData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject.children",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedRMFamily"
      },
      {
        "name": "copyRMCategoryData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject.children",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedRMCategory"
      },
      {
        "name": "getAgentData",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/agents/get?supplier={{fetchedData.selectedSupplierId}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.agentData"
      },
      {
        "name": "copySupplierData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.good.supplier"
      },
      {
        "name": "copyAgentData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.good.agent"
      },
      {
        "name": "saveGood",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/goods/save",
        "arg2Key": "postData",
        "arg2Value": "formData.good",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      }
    ]
  },
  "forRole": "COMMERCIAL_PURCHASER,COMMERCIAL_MANAGER,CUSTOMER_SERVICE_MANAGER",
  "visible": false
}